// src/services/psiConditionService.js
import { authenticatedFetch, handleApiError } from './api';

const API_URL = '/psi-conditions';

export const getAllConditions = () => {
  return authenticatedFetch(API_URL).catch(handleApiError);
};

export const createCondition = (conditionData) => {
  return authenticatedFetch(API_URL, {
    method: 'POST',
    body: JSON.stringify(conditionData),
  }).catch(handleApiError);
};
